import { Flex } from '@components/layout/grid/flex'
import type { FlexProps } from '@components/layout/grid/flex'
import classNames from 'classnames'
import type { PropsWithChildren } from 'react'
import { forwardRef } from 'react'

import styles from './row.module.scss'

export const Row = forwardRef<HTMLDivElement, PropsWithChildren<Props>>(
    ({ className, ...rest }, ref) => (
        <Flex
            ref={ref}
            className={classNames(styles.row, className)}
            {...rest}
        />
    ),
)

interface Props extends FlexProps {
    /**
     * Allow other classes to be passed to Row.
     */
    className?: string
}
